import { actionType } from "../actions/miljoKommentarerAction";
import { CreateNewReducer } from "../utils/reducerUtils";

const miljogebyrKommentarReducer = (state = {}, action) =>
  CreateNewReducer(state, action, actionType);

export default miljogebyrKommentarReducer;
